import ReactDOMServer from 'react-dom/server'

import CustomMarker from '@/components/map/components/naverMap/components/CustomMarker'
import NaverMapController from '@/components/map/components/naverMap/components/MapController'
import PoiIcon from '@/components/map/components/naverMap/components/Poi'
import useNaverMapViewModel, { type useNaverMapViewModelProps } from '@/components/map/components/naverMap/viewModel'

import type { ParkinglotDetail, SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Shared from '@/shared'
import Portal from '@/shared/components/Portal'
import Toast from '@/shared/components/Toast'

import { MarkerType } from '@/enums/map'

export interface NaverMapProps extends Omit<useNaverMapViewModelProps, 'generateSvgString' | 'airportMarker'> {
  width: number | string
  height: number | string
  pin?: ParkinglotDetail | SharedParkinglotDetail
}

export interface GenerateSvgStringParams {
  name: string
  price?: string
  markerType: MarkerType
  searchLat?: string
  searchLng?: string
  isOn: boolean
}

export default function View(props: NaverMapProps) {
  const generateSvgString = ({ name, price, markerType, isOn }: GenerateSvgStringParams) =>
    ReactDOMServer.renderToString(<PoiIcon name={name} price={price} markerType={markerType} isOn={isOn} />)

  const currentMarker = ReactDOMServer.renderToString(<CustomMarker.CurrentPositionMarker />)
  const airportMarker = ReactDOMServer.renderToString(<CustomMarker.AirportMarker />)

  const { states, setters } = useNaverMapViewModel({
    ...props,
    searchedLocationMarker: currentMarker,
    airportMarker: airportMarker,
    generateSvgString
  })

  const zoomToastProps = {
    text: states.zoomToast,
    position: 'belowTopBanner'
  }
  const markerToastProps = {
    text: states.markerToast,
    position: 'belowTopBanner'
  }

  const mapLayoutPositions = Shared.States.useMapLayoutPositions((state) => state.positions)

  return (
    <div className="relative z-10 w-full">
      <div className="absolute h-full w-full" style={{ padding: `0 ${mapLayoutPositions.paddingX}px` }}>
        <div className={`relative h-full w-full`}>
          <NaverMapController.ZoomLevelControlButton mapRef={states.naverMapRef} />
          <NaverMapController.CurrentLocationButton
            map={states.naverMapRef}
            locationMarker={currentMarker}
            isOn={states.isCurrentLocation}
            setIsOn={setters.setIsCurrentLocation}
          />
        </div>
      </div>
      <div id="map" style={{ width: props.width, height: props.height }} />

      {states.zoomToast ? (
        <Portal targetId="#layer1">
          <Toast {...zoomToastProps} />
        </Portal>
      ) : states.markerToast ? (
        <Portal targetId="#layer1">
          <Toast {...markerToastProps} />
        </Portal>
      ) : null}
    </div>
  )
}
